
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataDash, PostagemVisualizada } from "app/shared/models/home/dataDash";
import { RootObjectTrainingsDash, TrainingsDash } from "app/shared/models/home/tariningsDash";
import { ComplianceInformationReport } from "app/shared/models/reports/compliance-information/compliance-information-report";

/* Models */


/* Providers */
import { GenericRequestProvider } from "../../generic-request-provider";

@Injectable({
  providedIn: "root",
})
export class HomeProvider {
  constructor(private http: HttpClient) { }


  // listVews(): GenericRequestProvider<PostagemVisualizada> {
  //   return new GenericRequestProvider<PostagemVisualizada>(
  //     `api/dasboard/getdetailspostagemvisulizadadashboard`,
  //     this.http
  //   );
  // }

  listInfos(): GenericRequestProvider<ComplianceInformationReport> {
    return new GenericRequestProvider<ComplianceInformationReport>(
      `api/informacoescompliancereport/all`,
      this.http
    );
  }
  listTrainingsStatus(): GenericRequestProvider<RootObjectTrainingsDash['data']> {
    return new GenericRequestProvider<RootObjectTrainingsDash['data']>(
      `api/treinamento/relatorio/ultimos-dez`,
      this.http
    );
  }
  getInfosDash(): GenericRequestProvider<DataDash> {
    return new GenericRequestProvider<DataDash>(
      `api/dasboard/empresa`,
      this.http
    );
  }



}
